import { render, staticRenderFns } from "./gameHeader.vue?vue&type=template&id=bb6b0f14&scoped=true"
import script from "./gameHeader.vue?vue&type=script&lang=js"
export * from "./gameHeader.vue?vue&type=script&lang=js"
import style0 from "./gameHeader.vue?vue&type=style&index=0&id=bb6b0f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b0f14",
  null
  
)

export default component.exports